import React from 'react';
import { View, StyleSheet } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';
import { Chip } from 'react-native-paper';

interface ShareLinkInfo {
  templateId: number;
  templateName?: string;
  itemId?: number;
  itemName?: string;
  categoryId?: number;
  categoryName?: string;
  questionMappings?: unknown[];
}

interface ShareBadgeProps {
  sharedWith?: ShareLinkInfo[];
  onPress?: (link: ShareLinkInfo) => void;
  style?: StyleProp<ViewStyle>;
}

/**
 * Badge component to display sharing status for categories/items
 * Shows which other templates an item or category is shared with
 */
export const ShareBadge: React.FC<ShareBadgeProps> = ({
  sharedWith,
  onPress,
  style
}) => {
  if (!sharedWith || sharedWith.length === 0) {
    return null;
  }

  return (
    <View style={[styles.container, style]}>
      {sharedWith.map((link, index) => {
        const displayText = link.templateName
          ? `Shared with ${link.templateName}`
          : `Shared with Template ${link.templateId}`;

        return (
          <Chip
            key={index}
            mode="outlined"
            style={styles.chip}
            textStyle={styles.chipText}
            onPress={() => onPress?.(link)}
            icon="share-variant"
          >
            {displayText}
          </Chip>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 4,
    marginBottom: 4
  },
  chip: {
    marginRight: 8,
    marginBottom: 4,
    backgroundColor: '#E3F2FD',
    borderColor: '#2196F3'
  },
  chipText: {
    fontSize: 12,
    color: '#1976D2'
  }
});

export default ShareBadge;
